import React from 'react';
import { Button, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LotImageErrored = ({ errorDescription, fileName, handleDeleteFile, imageSrc, index }) => (
  <Col xs={3} className="file-container py-3">
    <div className="border-invalid px-3 pt-2">
      <div className="d-flex">{fileName}</div>
      <div className="thumb-container d-flex justify-content-center align-items-center mt-2 mb-3">
        {imageSrc && <img className="w-100 mh-100 opacity-50" src={imageSrc} alt="No Thumbnail" />}
        <FontAwesomeIcon
          icon="exclamation-triangle"
          size="3x"
          className="position-absolute color-danger"
        />
      </div>
      <Button className="mt-0" color="link" onClick={() => handleDeleteFile(index)}>
        Delete
      </Button>
    </div>
    <div className="text-danger my-2">{errorDescription}</div>
  </Col>
);

export default LotImageErrored;
